export interface ArticleSearchFormValue {
  search: string;
}
